<template>
  <div class="flex h-screen overflow-hidden">
    <SideBar :role="role" :collapsed="collapsed" :mobileOpen="mobileSidebarOpen" :isDesktop="isDesktop"
      @toggle="toggleSidebar" @close-mobile="closeMobileSidebar" @select="$emit('select', $event)" />

    <div class="flex flex-column flex-1 min-w-0 transition-all duration-300 ease-in-out"
      :class="[isDesktop ? (collapsed ? 'md:ml-6rem' : 'md:ml-16rem') : '']">

      <TopBar :role="role" :image="(profileImageUrl && profileImageUrl !== 'Service is not available in local environment') 
      ? profileImageUrl :blankProfile" @toggle-sidebar="toggleSidebarHandler">
        <div class="grid flex flex-column justify-content-between gap-2 col-10 profile-container">
          <div class="flex flex-wrap w-full gap-4 items-center justify-content-between">
            <div class="flex flex-wrap gap-4 items-center">
              <div class="flex justify-center md:justify-start">
                <img :src="(profileImageUrl && profileImageUrl !== 'Service is not available in local environment')
                 ? profileImageUrl :blankProfile" alt="Profile Image" class="profile-image" />
              </div>
              <div class="flex flex-column justify-content-center gap-1">
                <span class="text-left Paragraph-Medium" :class="role === 'institute' ? 'text-black' : 'text-white'">{{ currentUser?.username }}</span>
                <span class="Caption" :class="role === 'institute' ? 'text-black' : 'text-white'">{{ currentUser?.email }}</span>
              </div>
            </div>
            <div v-if="role === 'student'" class="flex flex-column justify-content-center gap-2">
              <span class="text-center Paragraph-Medium text-white">I prefer</span>
              <div class="card flex flex-wrap justify-content-center align-items-center">
                <span class="Label text-white px-2">Group Class</span>
                <ToggleSwitch v-model="checked" @change="updatePreference(checked)" />
                <span class="Label text-white px-2">Individual Class</span>
              </div>
            </div>
          </div>
        </div>
      </TopBar>

      <main class="flex-1 content-area overflow-y-auto transition-all duration-300 z-20">
        <div class="container-custom mx-auto pt-0">
          <slot></slot>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineProps, defineEmits, watch,computed } from "vue";
import SideBar from "@/components/settings/SideBar.vue";
import TopBar from "@/components/settings/TopBar.vue";
import ToggleSwitch from 'primevue/toggleswitch';
import blankProfile from '@/assets/blank-profile.png';
import { useAuthStore } from "@/stores/authStore";

const props = defineProps({
  role: {
    type: String,
    default: "student",
  },
  user: {
    type: Object,
  },
});
const emit = defineEmits(["update-prfile"]);
const authStore = useAuthStore();
const collapsed = ref(false);
const mobileSidebarOpen = ref(false);
const isDesktop = ref(window.innerWidth >= 1024);
const checked = ref(false);

const currentUser = computed(() => authStore.user || props.user);
const profileImageUrl = computed(() => authStore.profileImageUrl);

const toggleSidebarHandler = () => {
  mobileSidebarOpen.value = !mobileSidebarOpen.value;
};

const toggleSidebar = () => {
  collapsed.value = !collapsed.value;
};
const closeMobileSidebar = () => {
  mobileSidebarOpen.value = false;
};

const handleResize = () => {
  isDesktop.value = window.innerWidth >= 1024;
  if (isDesktop.value) mobileSidebarOpen.value = false;
};

const updatePreference = (checked) => {
  const preferredIndividualClass = checked ? true : false;
  const preferredGroupClass = !checked ? true : false;

  const payload = {
    preferredIndividualClass: preferredIndividualClass,
    preferredGroupClass: preferredGroupClass
  }
  emit("update-prfile", payload);
}
onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));

watch(
  () => props.user,
  (newUser) => {
    if (newUser) {
      checked.value = newUser?.preferredIndividualClass
    }
  }
);
</script>


<style scoped>
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.content-area {
  margin-top: -11vh !important;
  position: relative !important;
  z-index: 20 !important;
  margin: 18px 18px 0px 18px;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.profile-container {
  margin-top: -5vh !important;
}

.container-custom {
  display: flex !important;
  border-radius: 8px;
  padding: 10px !important;
  background-color: white;
  height: auto !important;
  width: 100%;
  display: inline-block !important;
  min-height: 50vh !important;
}

@media (max-width: 767px) {
  .content-area {
    margin-top: -1rem !important;
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
  }

  .container-custom {
    border-radius: 8px;
    display: inline-block !important;
  }
}


</style>
